<template>
  <div class="grid grid-cols-6 gap-4 p-5" id="group-editor-headers">
    <div class="font-bold">
      <vs-input v-model="rule.name"></vs-input>
    </div>
    <div>
      <vs-input v-model="rule.identity_name"></vs-input>
    </div>
    <div>
      <vs-input v-model="rule.weight"></vs-input>
    </div>
    <div>
      <vs-select v-model="rule.analysis_type.type" class="w-full">
        <vs-select-item
            v-for="(analysisType, idx) in analysisTypes"
            :key="idx"
            :value="analysisType.value"
            :text="analysisType.name"></vs-select-item>
      </vs-select>

      <vs-select
          v-model="rule.analysis_type.argument"
          v-if="rule.analysis_type.type === 'Catalog' || rule.analysis_type.type === 'CatalogInverseLine' || rule.analysis_type.type === 'CatalogPositiveLine'"
          class="w-full mt-2"
      >
        <vs-select-item
            v-for="catalog in catalogs"
            :text="catalog.category"
            :value="catalog.category"></vs-select-item>
      </vs-select>
    </div>
    <div>
      <vs-input v-model="rule.worst_value"></vs-input>
    </div>
    <div class="flex items-start">
      <vs-input v-model="rule.best_value"></vs-input>
      <vs-button
          @click="removeItemHandler"
          icon="delete" size="small" color="danger" class="ml-2 mt-2">
      </vs-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "RiskModelRuleItem",
  props: {
    catalogs: {
      type: Array,
      required: true,
      default: () => []
    },
    analysisTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    rule: {
      type: Object,
      default: () => ({
        name: '',
        identity_name: '',
        weight: 0,
        analysis_type: {
          type: "",
          argument: ''
        },
        worst_value: 0,
        best_value: 0
      })
    }
  },
  methods: {
    removeItemHandler() {
      this.$emit('onRemoveItem', this.rule)
    }
  }
}
</script>
<style scoped>

</style>